import { styled } from "styled-components";

export const Form = styled.form`
`
export const TrackingVideoContainer = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
`
export const TrackingVideoLabel = styled.label`
`